import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';
import { ProfileErrorCodes } from '../error-codes/profile.type';
import { NotificationsSuccessCodes } from '../success-codes/notifications.type';
import { OrganisationSuccessCodes } from '../success-codes/others.type';
import { defaultOtherTranslations } from './en-GB/other-translations';
import { SupportedToasterLocales } from './general.utils';

export const otherTranslations: {
  // For new locales just add them here to the extract
  [key in SupportedToasterLocales]: typeof defaultOtherTranslations;
} = {
  [Locale.en_GB]: defaultOtherTranslations,
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateOtherAlerts = (translations: typeof defaultOtherTranslations) => ({
  [NotificationsSuccessCodes.UPDATE_SUCCESSFUL]: {
    name: 'Notification update success',
    type: AlertTypes.SUCCESS,
    title: translations.NOTIFICATION_UPDATE_SUCCESS_TITLE,
    description: translations.NOTIFICATION_UPDATE_SUCCESS_DESCRIPTION,
  },
  [OrganisationSuccessCodes.ORGANISATION_SWITCH_SUCCESSFUL]: {
    name: 'Organisation switch success',
    type: AlertTypes.SUCCESS,
    title: translations.ORGANISATION_SWITCH_SUCCESSFUL_TITLE,
    description: translations.ORGANISATION_SWITCH_SUCCESSFUL_DESCRIPTION,
  },
  [ProfileErrorCodes.BIOMETRIC_AUTH_ENABLED_SUCCESSFULLY]: {
    name: translations.BIOMETRIC_AUTH_ENABLED_DESCRIPTION,
    type: AlertTypes.SUCCESS,
    title: translations.BIOMETRIC_AUTH_ENABLED_TITLE,
    description: translations.BIOMETRIC_AUTH_ENABLED_DESCRIPTION,
  },
  [ProfileErrorCodes.BIOMETRIC_AUTH_DISABLED_SUCCESSFULLY]: {
    name: translations.BIOMETRIC_AUTH_DISABLED_DESCRIPTION,
    type: AlertTypes.SUCCESS,
    title: translations.BIOMETRIC_AUTH_DISABLED_TITLE,
    description: translations.BIOMETRIC_AUTH_DISABLED_DESCRIPTION,
  },
});
